import { makeStyles } from 'tss-react/mui'
import { fundingColors as C } from '../../theme/fundingColors'
import { FUNDING_FORM_FIELD_HEIGHT } from '../../theme/fundingSharedStyles'
import { fundingFont } from '../../theme/fundingTypography'

export const useStyles = makeStyles()(() => ({
  root: {
    width: '100%',
    minWidth: 0,
    fontFamily: fundingFont,
    '& .MuiFormControl-root': {
      width: '100%',
    },
    '& .MuiOutlinedInput-root': {
      boxSizing: 'border-box',
      minHeight: FUNDING_FORM_FIELD_HEIGHT,
      height: FUNDING_FORM_FIELD_HEIGHT,
      flexWrap: 'nowrap',
      alignItems: 'center',
      overflowX: 'auto',
      overflowY: 'hidden',
      padding: '8px 40px 8px 12px',
      gap: 4,
      fontFamily: fundingFont,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '20px',
      letterSpacing: '0.25px',
      color: C.darkText,
      backgroundColor: C.cardBg,
      borderRadius: 4,
      '& fieldset': {
        borderColor: C.buttonBorder,
      },
      '&:hover fieldset': {
        borderColor: C.buttonBorder,
      },
      '&.Mui-focused fieldset': {
        borderColor: C.linkBlue,
        borderWidth: 1,
      },
    },
    '& .MuiOutlinedInput-input': {
      padding: '2px 0',
      margin: 0,
      minWidth: 40,
      minHeight: 20,
      height: 'auto',
      flex: '1 0 auto',
      fontFamily: fundingFont,
      fontSize: 14,
      lineHeight: '20px',
      letterSpacing: '0.25px',
      color: C.darkText,
      '&::placeholder': {
        color: C.mutedText,
        opacity: 1,
      },
    },
    '& .MuiAutocomplete-endAdornment': {
      top: '50%',
      transform: 'translateY(-50%)',
      right: 8,
    },
    '& .MuiChip-root': {
      height: 24,
      maxWidth: 'none',
      flexShrink: 0,
      margin: '0 4px 0 0',
      fontFamily: fundingFont,
      fontSize: 12,
      lineHeight: '16px',
    },
    '& .MuiChip-label': {
      paddingLeft: 8,
      paddingRight: 8,
    },
  },
  /**
   * Multi-select: grow with chips (never clip below a fixed 44px).
   * Overrides the base single-line height / nowrap.
   */
  rootAllowWrap: {
    '& .MuiOutlinedInput-root': {
      height: 'auto !important',
      minHeight: FUNDING_FORM_FIELD_HEIGHT,
      flexWrap: 'wrap',
      alignContent: 'center',
      alignItems: 'center',
      overflowX: 'hidden',
      overflowY: 'visible',
      paddingTop: 8,
      paddingBottom: 8,
    },
    '& .MuiChip-root': {
      margin: '2px 4px 2px 0',
    },
    '& .MuiAutocomplete-endAdornment': {
      top: 12,
      transform: 'none',
    },
  },
  floatFieldRoot: {
    // minHeight only — never lock height (multi chips must expand).
    '& .MuiOutlinedInput-root': {
      minHeight: FUNDING_FORM_FIELD_HEIGHT,
      height: 'auto',
      paddingTop: 10,
      paddingBottom: 10,
      alignItems: 'center',
    },
    '& .MuiInputLabel-root:not(.MuiInputLabel-shrink)': {
      transform: 'translate(14px, 12px) scale(1)',
    },
  },
  /** Floated label sits on the border — keep padding symmetric so value/chips stay centered. */
  floatFieldRootFloated: {
    '& .MuiOutlinedInput-root': {
      paddingTop: 10,
      paddingBottom: 10,
      alignItems: 'center',
      alignContent: 'center',
    },
    '& .MuiAutocomplete-endAdornment': {
      top: '50%',
      transform: 'translateY(-50%)',
    },
  },
  floatLabel: {
    fontFamily: fundingFont,
    fontSize: 14,
    lineHeight: '20px',
    color: C.mutedText,
    backgroundColor: C.cardBg,
    padding: '0 2px',
    '&.MuiInputLabel-shrink': {
      fontSize: 12,
      lineHeight: '16px',
      color: C.mutedText,
      transform: 'translate(14px, -8px) scale(0.85)',
    },
  },
  endAction: {
    display: 'inline-flex',
    alignItems: 'center',
    marginRight: 4,
  },
  /** Popper listbox is portaled outside `.root` — theme font must be set here. */
  listboxPaper: {
    fontFamily: fundingFont,
  },
  listbox: {
    fontFamily: fundingFont,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: C.darkText,
    padding: '4px 0',
    '& .MuiAutocomplete-option': {
      fontFamily: fundingFont,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '20px',
      letterSpacing: '0.25px',
      color: C.darkText,
    },
  },
  option: {
    fontFamily: fundingFont,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: C.darkText,
  },
  optionTooltipTarget: {
    display: 'inline-flex',
    alignItems: 'center',
    minWidth: 0,
    maxWidth: '100%',
    fontFamily: 'inherit',
    fontSize: 'inherit',
    lineHeight: 'inherit',
  },
}))
